export default "__VITE_ASSET__DkwWQyaH__"